import formatISO from 'date-fns/formatISO';
import parseISO from 'date-fns/parseISO';

const prepareDateForRequest = (date: Date | null | undefined): string => {
  if (!date) {
    return '';
  }

  return formatISO(date);
};

const prepareDate = (input: string | null | undefined): Date | null => {
  if (!input) {
    return null;
  }

  return parseISO(input);
};

const parseDateOnly = (input: string | null | undefined): Date | null => {
  if (!input) {
    return null;
  }

  const match = input.match(/^(\d{4})-(\d{2})-(\d{2})/);

  if (!match) {
    return null;
  }

  const [, year, month, day] = match;

  return new Date(Number(year), Number(month) - 1, Number(day));
};

export { prepareDateForRequest, prepareDate, parseDateOnly };
